import {gql} from '@apollo/client';

export default gql`
  query getBrandCampaignAttributionReferrerDomains(
    $organizationId: ID!
    $id: ID!
    $offset: Int
    $limit: Int
  ) {
    me {
      id
      organization(id: $organizationId) {
        id
        campaign(id: $id) {
          id
          attribution {
            users {
              referrerDomains {
                count
                sum
                nodes(offset: $offset, limit: $limit) {
                  referrerDomain
                  count
                }
              }
            }
          }
        }
      }
    }
  }
`;
